const lastOpenedWorkspace = localStorage.getItem('lastOpenedWorkspace')

export default {
  token: null,
  asuToken: null,
  workspace: 0,
  isVersionCopying: false,
  isWorkspaceCopying: false,
  lastOpenedWorkspace: lastOpenedWorkspace,
  version: '',
  versionList: [],
  workspaceList: [],
  activeWorkspaceList: null,
  lastTimeVersionRequest: '',
  versionRequestInterval: null,
  newVersionExists: null,

  /**Права пользователя */
  permissions: [],

  /**
   * Специальный промис, который нужен чтобы избегать повторного запроса данных пользователя,
   * но при этом выполнять действия после загрузки прав
   * например используется при проверки доступа к маршрутам vue router
   */
  userDataPromise: null,

  /**Имя пользователя */
  userName: null,

  /**Идентификатор пользователя */
  userId: null,

  /**Группы пользователя */
  userGroups: null,

  /**Отделы пользователя */
  userDepartments: null,

  /**Кол-во доступных версий ws */
  userAvailableVersions: null,
}



// WEBPACK FOOTER //
// ./src/store/auth/defaults.js